// @flow

import { useState, useEffect } from 'react';
import { init } from '@ebanx/ebanx-js';
import { type IncomingPayment, getCountry, getMerchant } from '@tectonics/prs/incoming-payment';
import { getPublicIntegrationKey } from '@tectonics/prs/merchant';

export function useEbanxJsInitialization(payment: ?IncomingPayment) {
  const [country, setCountry] = useState<string>('');
  const [mode, setMode] = useState<string>('');
  const [publicIntegrationKey, setPublicIntegrationKey] = useState<string>('');

  useEffect(() => {
    if (!country || !mode || !publicIntegrationKey) {
      return;
    }
    init({ country, mode, publicIntegrationKey });
  }, [country, mode, publicIntegrationKey]);

  useEffect(() => {
    if (!payment) {
      return;
    }

    setCountry(getCountry(payment));
    setMode(ENV_CONSTANTS.ENV === 'production' ? 'production' : 'test');
    setPublicIntegrationKey(getPublicIntegrationKey(getMerchant(payment)));
  }, [payment]);
}
